import CryptoJS, {AES} from 'crypto-js';

export function dec(cypher, password){
    const result = AES.decrypt(cypher, password).toString(CryptoJS.enc.Utf8);
    return result;
}